import { clsx } from 'clsx';
import * as React from 'react';

import styles from './ChatMessageBubble.css';
import { IconTail } from './assets/icons';
import { EMessageType } from '../../types/messageType';
import { EUserColor } from '../../types/userName';
import { noop } from '../../utils/noop';

interface IChatMessageBubbleProps {
  messageType: EMessageType;
  withTail: boolean;
  className?: string;
  userColor?: EUserColor;
  highlighted?: boolean;
  children: React.ReactNode;
  onHighlightEnd?: VoidFunction;
}

export const ChatMessageBubble = React.forwardRef<HTMLDivElement, IChatMessageBubbleProps>(function ChatMessageBubble(
  { children, messageType, withTail, className, userColor, highlighted = false, onHighlightEnd = noop },
  ref,
) {
  const handleHighlightAnimationEnd = React.useCallback(() => {
    setTimeout(onHighlightEnd, 300);
  }, [onHighlightEnd]);

  return (
    <div
      className={clsx(
        styles['message-bubble'],
        styles[`message-bubble_type_${messageType}`],
        userColor && styles[`message-bubble_theme_${userColor}`],
      )}
      ref={ref}
      data-testid="ChatMessageBubble"
    >
      <div className={clsx(styles['message-bubble__content'], className)}>{children}</div>

      {highlighted && (
        <div
          className={styles['message-bubble__highlight-overlay']}
          data-testid="HighlightOverlay"
          onAnimationEnd={handleHighlightAnimationEnd}
        />
      )}

      {withTail && (
        <div className={styles['message-bubble__tail']}>
          <IconTail />
        </div>
      )}
    </div>
  );
});
